import {
    FETCH_SERVICES,
    FETCH_SERVICE_DETAIL,
    CREATE_SERVICE,
    UPDATE_SERVICE,
    DELETE_SERVICES,
    FETCH_ACTIVE_SERVICES
} from '@/redux/actions/types';

/**
 * Trạng thái khởi tạo cho module Services
 */
const INIT_STATE = {
    list: {
        items: []
    },
    activeList: {
        items: []
    },
    detail: null,
    createResult: null,
    updateResult: null,
    deleteResult: null
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_SERVICES: {
            return {
                ...state,
                list: {
                    items: action.payload?.data || []
                }
            };
        }

        case FETCH_ACTIVE_SERVICES: {
            return {
                ...state,
                activeList: {
                    items: action.payload?.data || []
                }
            };
        }

        case FETCH_SERVICE_DETAIL: {
            return {
                ...state,
                detail: action.payload || null
            };
        }

        case CREATE_SERVICE: {
            return {
                ...state,
                createResult: action.payload || null
            };
        }

        case UPDATE_SERVICE: {
            return {
                ...state,
                updateResult: action.payload || null
            };
        }

        case DELETE_SERVICES: {
            return {
                ...state,
                deleteResult: action.payload || null
            };
        }

        default:
            return state;
    }
};
